import { render, staticRenderFns } from "./EneriqMetadataNewsfeed.global.vue?vue&type=template&id=fa6b6cfc&scoped=true&"
import script from "./EneriqMetadataNewsfeed.global.vue?vue&type=script&lang=ts&"
export * from "./EneriqMetadataNewsfeed.global.vue?vue&type=script&lang=ts&"
import style0 from "./EneriqMetadataNewsfeed.global.vue?vue&type=style&index=0&id=fa6b6cfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6b6cfc",
  null
  
)

export default component.exports